module.exports = __webpack_public_path__ + "img/Infografis_EN_18.8be22b21.jpg";